module.exports = __webpack_public_path__ + "static/media/pro4.00d89406.png";